import React from 'react';

const Head = (props) => {
    return (    
    <header id="home" className="header-icons overlay">
        <div className="background-image-holder parallax-background">
            <img className="background-image" alt="" src="img/header_image.jpg" />
        </div>
        <div className="container">
            <div className="row">
                <div className="col-sm-12">
                    <h1 className="text-white">{ props.title_one }<br />{ props.title_two }</h1>
                </div>
            </div>
            <div className="row">
                {props.icons ? props.icons.map((item, itemIndex) => {
                    return (
                        <div className="col-sm-4" key={itemIndex}>
                            <i className={`icon text-white ${item.icon}`}></i>
                            <h2 className="text-white">{item.title}</h2>
                        </div>
                    );
                }) : null}
            </div>
        </div>
    </header>
    )
}

export default Head;